export enum CURRENCIES {
  "AED" = "United Arab Emirates Dirham",
  "AFN" = "Afghan Afghani",
  "ALL" = "Albanian Lek",
  "AMD" = "Armenian Dram",
  "ANG" = "Netherlands Antillean Guilder",
  "AOA" = "Angolan Kwanza",
  "ARS" = "Argentine Peso",
  "AUD" = "Australian Dollar",
  "AWG" = "Aruban Florin",
  "AZN" = "Azerbaijani Manat",
  "BAM" = "Bosnia-Herzegovina Convertible Mark",
  "BBD" = "Barbadian Dollar",
  "BDT" = "Bangladeshi Taka",
  "BGN" = "Bulgarian Lev",
  "BHD" = "Bahraini Dinar",
  "BIF" = "Burundian Franc",
  "BMD" = "Bermudan Dollar",
  "BND" = "Brunei Dollar",
  "BOB" = "Bolivian Boliviano",
  "BRL" = "Brazilian Real",
  "BSD" = "Bahamian Dollar",
  "BTC" = "Bitcoin",
  "BTN" = "Bhutanese Ngultrum",
  "BWP" = "Botswanan Pula",
  "BYN" = "Belarusian Ruble",
  "BZD" = "Belize Dollar",
  "CAD" = "Canadian Dollar",
  "CDF" = "Congolese Franc",
  "CHF" = "Swiss Franc",
  "CLF" = "Chilean Unit of Account (UF)",
  "CLP" = "Chilean Peso",
  "CNH" = "Chinese Yuan (Offshore)",
  "CNY" = "Chinese Yuan",
  "COP" = "Colombian Peso",
  "CRC" = "Costa Rican Colón",
  "CUC" = "Cuban Convertible Peso",
  "CUP" = "Cuban Peso",
  "CVE" = "Cape Verdean Escudo",
  "CZK" = "Czech Republic Koruna",
  "DJF" = "Djiboutian Franc",
  "DKK" = "Danish Krone",
  "DOP" = "Dominican Peso",
  "DZD" = "Algerian Dinar",
  "EGP" = "Egyptian Pound",
  "ERN" = "Eritrean Nakfa",
  "ETB" = "Ethiopian Birr",
  "EUR" = "Euro",
  "FJD" = "Fijian Dollar",
  "FKP" = "Falkland Islands Pound",
  "GBP" = "British Pound Sterling",
  "GEL" = "Georgian Lari",
  "GGP" = "Guernsey Pound",
  "GHS" = "Ghanaian Cedi",
  "GIP" = "Gibraltar Pound",
  "GMD" = "Gambian Dalasi",
  "GNF" = "Guinean Franc",
  "GTQ" = "Guatemalan Quetzal",
  "GYD" = "Guyanaese Dollar",
  "HKD" = "Hong Kong Dollar",
  "HNL" = "Honduran Lempira",
  "HRK" = "Croatian Kuna",
  "HTG" = "Haitian Gourde",
  "HUF" = "Hungarian Forint",
  "IDR" = "Indonesian Rupiah",
  "ILS" = "Israeli New Sheqel",
  "IMP" = "Manx pound",
  "INR" = "Indian Rupee",
  "IQD" = "Iraqi Dinar",
  "IRR" = "Iranian Rial",
  "ISK" = "Icelandic Króna",
  "JEP" = "Jersey Pound",
  "JMD" = "Jamaican Dollar",
  "JOD" = "Jordanian Dinar",
  "JPY" = "Japanese Yen",
  "KES" = "Kenyan Shilling",
  "KGS" = "Kyrgystani Som",
  "KHR" = "Cambodian Riel",
  "KMF" = "Comorian Franc",
  "KPW" = "North Korean Won",
  "KRW" = "South Korean Won",
  "KWD" = "Kuwaiti Dinar",
  "KYD" = "Cayman Islands Dollar",
  "KZT" = "Kazakhstani Tenge",
  "LAK" = "Laotian Kip",
  "LBP" = "Lebanese Pound",
  "LKR" = "Sri Lankan Rupee",
  "LRD" = "Liberian Dollar",
  "LSL" = "Lesotho Loti",
  "LYD" = "Libyan Dinar",
  "MAD" = "Moroccan Dirham",
  "MDL" = "Moldovan Leu",
  "MGA" = "Malagasy Ariary",
  "MKD" = "Macedonian Denar",
  "MMK" = "Myanma Kyat",
  "MNT" = "Mongolian Tugrik",
  "MOP" = "Macanese Pataca",
  "MRO" = "Mauritanian Ouguiya (pre-2018)",
  "MRU" = "Mauritanian Ouguiya",
  "MUR" = "Mauritian Rupee",
  "MVR" = "Maldivian Rufiyaa",
  "MWK" = "Malawian Kwacha",
  "MXN" = "Mexican Peso",
  "MYR" = "Malaysian Ringgit",
  "MZN" = "Mozambican Metical",
  "NAD" = "Namibian Dollar",
  "NGN" = "Nigerian Naira",
  "NIO" = "Nicaraguan Córdoba",
  "NOK" = "Norwegian Krone",
  "NPR" = "Nepalese Rupee",
  "NZD" = "New Zealand Dollar",
  "OMR" = "Omani Rial",
  "PAB" = "Panamanian Balboa",
  "PEN" = "Peruvian Nuevo Sol",
  "PGK" = "Papua New Guinean Kina",
  "PHP" = "Philippine Peso",
  "PKR" = "Pakistani Rupee",
  "PLN" = "Polish Zloty",
  "PYG" = "Paraguayan Guarani",
  "QAR" = "Qatari Rial",
  "RON" = "Romanian Leu",
  "RSD" = "Serbian Dinar",
  "RUB" = "Russian Ruble",
  "RWF" = "Rwandan Franc",
  "SAR" = "Saudi Riyal",
  "SBD" = "Solomon Islands Dollar",
  "SCR" = "Seychellois Rupee",
  "SDG" = "Sudanese Pound",
  "SEK" = "Swedish Krona",
  "SGD" = "Singapore Dollar",
  "SHP" = "Saint Helena Pound",
  "SLL" = "Sierra Leonean Leone",
  "SOS" = "Somali Shilling",
  "SRD" = "Surinamese Dollar",
  "SSP" = "South Sudanese Pound",
  "STD" = "São Tomé and Príncipe Dobra (pre-2018)",
  "STN" = "São Tomé and Príncipe Dobra",
  "SVC" = "Salvadoran Colón",
  "SYP" = "Syrian Pound",
  "SZL" = "Swazi Lilangeni",
  "THB" = "Thai Baht",
  "TJS" = "Tajikistani Somoni",
  "TMT" = "Turkmenistani Manat",
  "TND" = "Tunisian Dinar",
  "TOP" = "Tongan Pa'anga",
  "TRY" = "Turkish Lira",
  "TTD" = "Trinidad and Tobago Dollar",
  "TWD" = "New Taiwan Dollar",
  "TZS" = "Tanzanian Shilling",
  "UAH" = "Ukrainian Hryvnia",
  "UGX" = "Ugandan Shilling",
  "USD" = "United States Dollar",
  "UYU" = "Uruguayan Peso",
  "UZS" = "Uzbekistan Som",
  "VEF" = "Venezuelan Bolívar Fuerte",
  "VND" = "Vietnamese Dong",
  "VUV" = "Vanuatu Vatu",
  "WST" = "Samoan Tala",
  "XAF" = "CFA Franc BEAC",
  "XAG" = "Silver Ounce",
  "XAU" = "Gold Ounce",
  "XCD" = "East Caribbean Dollar",
  "XDR" = "Special Drawing Rights",
  "XOF" = "CFA Franc BCEAO",
  "XPD" = "Palladium Ounce",
  "XPF" = "CFP Franc",
  "XPT" = "Platinum Ounce",
  "YER" = "Yemeni Rial",
  "ZAR" = "South African Rand",
  "ZMW" = "Zambian Kwacha",
  "ZWL" = "Zimbabwean Dollar",
}

export enum NewTransactionCurrencyEnum {
  "USD" = "United States Dollar [USD]",
  "EUR" = "Euro [EUR]",
  "CAD" = "Canadian Dollar [CAD]",
  "GBP" = "British Pound Sterling [GBP]",
  "TRY" = "Turkish Lira [TRY]",
  "SEK" = "Swedish Krona [SEK]",
  "BRL" = "Brazilian Real [BRL]",
  "BYN" = "Belarusian Ruble [BYN]",
  "CNY" = "Chinese Yuan [CNY]",
  "INR" = "Indian Rupee[INR]",
}

export enum VIRTUAL_WALLET_CURRENCY {
  "USD" = "United States Dollar [USD]",
  "INR" = "Indian Rupee [INR]",
  "HKD" = "Hong Kong Dollar [HKD]",
}

export const VIRTUAL_WALLET_CURRENCY_SYMBOLS = {
  USD: "$",
  INR: "₹",
  HKD: "HK$",
};

export enum ZotaCurrencyEnum {
  "USD" = "United States Dollar [USD]",
  "EUR" = "Euro [EUR]",
  "MYR" = "Malaysian Ringgit [MYR]",
  "IDR" = "Indonesian Rupiah [IDR]",
  "THB" = "Thai Baht [THB]",
  "JPY" = "Japanese Yen [JPY]",
  "VND" = "Vietnamese dong [VND]",
  "INR" = "Indian Rupee[INR]",
  "PHP" = "Philippine Peso [PHP]",
  "PKR" = "Pakistani Rupee [PKR]",
}

export enum TeslaPayCurrencyEnum {
  TRY = "TRY",
  RUB = "RUB", // Russian Ruble
  INR = "INR",
  PKR = "PKR", // Pakistan Rupee
  AZN = "AZN", // Azerbaijan Manat
  USDT = "USDT",
}

export enum TDayPayCurrencyEnum {
  BRL = "BRL",
  MXN = "MXN",
  COP = "COP",
  CLP = "CLP",
  PEN = "PEN",
  ECS = "ECS",
  VES = "VES",
}

export enum QuantumCurrencyEnum {
  INR = "INR",
}

export const UNSUPPORTED_CONVERSION_CURRENCIES = ["CNY", "BYN"];

export enum ETransactIoCurrency {
  "THB" = "THB",
  "MYR" = "MYR",
  "VND" = "VND",
  "IDR" = "IDR",
  "INR" = "INR",
  "CNY" = "CNY",
}

export enum VIRTUAL_WALLET_CURRENCY_CODES {
  "USD" = "USD",
  "INR" = "INR",
  "HKD" = "HKD",
}

export enum EWertCurrency {
  "USDT" = "USDT",
  "USDTTRON" = "USDT-TRON",
  "ETH" = "ETH",
  "BTC" = "BTC",
}

export enum ClipCurrenyEnum {
  MXN = "MXN",
}

export enum ChargeMoneyCurrencyEnum {
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
}

export enum PayrockCurrencyEnum {
  MYR = "MYR",
  IDR = "IDR",
  JPY = "JPY",
  INR = "INR",
}

export enum PayrockMyrEnum {
  BANK_TRANSFER = "Bank Transfer",
  DUITNOW = "Duitnow",
}

export enum PayrockIdrEnum {
  VIRTUAL_ACCOUNT = "Virtual Account",
  QRIS = "Qris",
  E_WALLETS = "E-Wallets",
}

export enum PayrockJypEnum {
  P2C = "P2C Bank Transfer",
}

export enum PayrockInrEnum {
  UPI = "UPI",
}

export enum StoplightEnum {
  USD = "USD",
}

export enum MuweEnum {
  MXN = "MXN",
}

export enum MuweMXNEnum {
  SPEI = "SPEI",
  CASH = "CASH",
}

export enum ConektaCurrencyEnum {
  MXN = "MXN",
}

export enum PayzaroCurrencyEnum {
  INR = "INR",
}

export enum PayzaroModeEnum {
  UPI = "UPI",
}

export enum NuveiEnum {
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
  JPY = "JPY",
  CHF = "CHF",
  MYR = "MYR",
  IDR = "IDR",
  INR = "INR",
}
